(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7504],{

/***/ 30967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconFacebook = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 8 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M4.873 16.107H1.646V8.303H.03V5.612h1.615V3.997c0-2.194.91-3.499 3.497-3.499h2.155v2.69H5.95c-1.007 0-1.074.376-1.074 1.077l-.004 1.347h2.441l-.286 2.69H4.873v7.805Z",
  fill: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconFacebook);

/***/ }),

/***/ 89796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconLinkedin = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M3.266 12.257H.733V4.632h2.533v7.627-.002ZM2.001 3.59h-.018C1.132 3.59.582 3.004.582 2.27c0-.732.566-1.318 1.434-1.318.867 0 1.402.57 1.417 1.318 0 .733-.55 1.319-1.434 1.319h.002Zm10.407 8.667H9.873v-4.08c0-1.026-.367-1.725-1.284-1.725-.7 0-1.117.472-1.3.927-.068.163-.084.39-.084.618v4.26H4.67s.033-6.911 0-7.627h2.535v1.081c.336-.518.938-1.259 2.284-1.259 1.668 0 2.919 1.09 2.919 3.432v4.373Z",
  fill: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconLinkedin);

/***/ }),

/***/ 37021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconX = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 300 301",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
  clipPath: "url(#icon-x_svg__a)"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59H300M36.01 19.54h40.65l187.13 262.13h-40.66",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
  id: "icon-x_svg__a"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "#fff",
  d: "M0 0h300v300.251H0z"
})))));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconX);

/***/ }),

/***/ 28264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[_name]",
      function () {
        return __webpack_require__(41399);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42998);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);




var LineSeparator = function(param) {
    var _width = param.width, width = _width === void 0 ? false : _width, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: width ? {
            width: width
        } : {},
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("separator", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineSeparator);


/***/ }),

/***/ 50331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78897);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);



var Spinner = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("spinner", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 93019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51524);
/* harmony import */ var _elements_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50331);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17570);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40670);





var LoadingPage = function(param) {
    var _title = param.title, title = _title === void 0 ? "Loading" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? false : _subtitle, _spinner = param.spinner, spinner = _spinner === void 0 ? true : _spinner;
    var isTablet = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)().isTablet;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().page),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_1__["default"], {
            variant: [
                "-xs2"
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: subtitle
                }),
                spinner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().page__spinner),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: [
                            !isTablet && "xl",
                            "darker"
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LoadingPage);


/***/ }),

/***/ 6553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91298);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);


var Page = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3790), __webpack_require__.e(175), __webpack_require__.e(6820), __webpack_require__.e(8433), __webpack_require__.e(3817)]).then(__webpack_require__.bind(__webpack_require__, 51904));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51904)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});
var Section = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5718)]).then(__webpack_require__.bind(__webpack_require__, 24447));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24447)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});
var Container = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 1524).then(__webpack_require__.bind(__webpack_require__, 51524));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51524)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});
var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5718)]).then(__webpack_require__.bind(__webpack_require__, 24447));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24447)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});

var FourOhFour = function(param) {
    var headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, ctaTranslation = param.ctaTranslation;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Page, {
        ctaTranslation: ctaTranslation,
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        meta: {
            title: "404 - Error Page | St. Martin Sotheby's Realty",
            description: "404 - Error Page | St. Martin Sotheby's Realty"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Section, {
            variant: [
                "center"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content__title),
                            children: "Sorry, no page found"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content__separator)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content__description),
                            children: "WE COULDN’T FIND WHAT YOU’RE LOOKING FOR"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                            href: "/vacation-rentals",
                            arrow: false,
                            children: "browse our properties"
                        })
                    ]
                })
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (FourOhFour);


/***/ }),

/***/ 41399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _name_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/templates/Page/index.js + 16 modules
var Page = __webpack_require__(51904);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/pages/singleBlog/Welcome/styles.module.scss
var styles_module = __webpack_require__(52976);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/elements/LineSeparator/index.js
var LineSeparator = __webpack_require__(96143);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/helpers/getS3Url.js
var getS3Url = __webpack_require__(27895);
;// CONCATENATED MODULE: ./components/pages/singleBlog/Welcome/index.js







var Welcome = function(param) {
    var title = param.title, date = param.date, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "prefetch",
                    href: image,
                    as: "image",
                    type: "image/jpeg"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
                variant: [
                    "center",
                    "pb0",
                    "bg-body"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                    variant: [
                        "-xl2"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).intro,
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (styles_module_default()).intro__title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineSeparator/* default */.Z, {
                                variant: [
                                    "center"
                                ]
                            }),
                            date && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).intro__subtitle,
                                children: date
                            }),
                            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).intro__image,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,getS3Url/* getS3Url */.v)(image, "1980"),
                                    srcSet: "\n                    ".concat((0,getS3Url/* getS3Url */.v)(image, "360"), " 360w,\n                    ").concat((0,getS3Url/* getS3Url */.v)(image, "640"), " 640w,\n                    ").concat((0,getS3Url/* getS3Url */.v)(image, "960"), " 960w,\n                    ").concat((0,getS3Url/* getS3Url */.v)(image, "1980"), " 1980w\n                  "),
                                    sizes: "100vw",
                                    alt: title || "Blog Post Image",
                                    style: {
                                        objectFit: "cover",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%"
                                    },
                                    fetchpriority: "high"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var singleBlog_Welcome = (Welcome);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-summary.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconSummary = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 30,
  height: 10,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M.602.203h28.8v3.2H.602v-3.2Zm6.4 6.4h22.4v3.2h-22.4v-3.2Z",
  fill: "#666"
})));

/* harmony default export */ var icon_summary = (SvgIconSummary);
;// CONCATENATED MODULE: ./public/icons/icon-table-contents.svg
var icon_table_contents_path;

function icon_table_contents_extends() { icon_table_contents_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_table_contents_extends.apply(this, arguments); }



const SvgIconTableContents = props => /*#__PURE__*/react.createElement("svg", icon_table_contents_extends({
  width: 31,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_table_contents_path || (icon_table_contents_path = /*#__PURE__*/react.createElement("path", {
  d: "M.992 4.008h23.295V.68H.992v3.328Zm0 6.655h23.295V7.335H.992v3.328Zm0 6.656h23.295V13.99H.992v3.328Zm26.623 0h3.328V13.99h-3.328v3.328Zm0-16.64v3.329h3.328V.68h-3.328Zm0 9.984h3.328V7.335h-3.328v3.328Z",
  fill: "#666"
})));

/* harmony default export */ var icon_table_contents = (SvgIconTableContents);
// EXTERNAL MODULE: ./components/elements/LazyImage/index.js
var LazyImage = __webpack_require__(20027);
// EXTERNAL MODULE: ./pages/stories/styles.module.scss
var stories_styles_module = __webpack_require__(86810);
var stories_styles_module_default = /*#__PURE__*/__webpack_require__.n(stories_styles_module);
;// CONCATENATED MODULE: ./components/helpers/addLinkTarget.js
var addLinkTarget = function(arr) {
    var parts = arr.split(/(<a\s+[^>]*href\s*=\s*"[^"]*"[^>]*>)/gi);
    var modifiedParts = parts.map(function(part) {
        // Check if the part includes an href attribute
        if (part.includes('href="')) {
            var modifiedPart = part.replace(/href\s*=\s*"([^"]*)"/i, function(match, p1) {
                // Check if the href value does not include 'sxmsir.com'
                // eslint-disable-next-line no-undef
                if (!p1.includes("https://sxmsir.com")) {
                    // Add target="_blank" to the href attribute
                    return 'href="'.concat(p1, '" target="_blank"');
                }
                // Return the original href attribute if it includes 'sxmsir.com'
                return match;
            });
            return modifiedPart;
        }
        // Return the original part if it doesn't include an href attribute
        return part;
    });
    var modifiedArr = modifiedParts.join("");
    return modifiedArr;
};

// EXTERNAL MODULE: ./components/pages/singleBlog/Paragraph/styles.module.scss
var Paragraph_styles_module = __webpack_require__(58886);
var Paragraph_styles_module_default = /*#__PURE__*/__webpack_require__.n(Paragraph_styles_module);
;// CONCATENATED MODULE: ./components/pages/singleBlog/Paragraph/index.js




var Paragraph = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Paragraph_styles_module_default()).paragraph,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            variant: [
                "-xs2",
                "-pxl"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: addLinkTarget(content)
                }
            })
        })
    });
};
/* harmony default export */ var singleBlog_Paragraph = (Paragraph);

// EXTERNAL MODULE: ./components/pages/singleBlog/Title/styles.module.scss
var Title_styles_module = __webpack_require__(78576);
var Title_styles_module_default = /*#__PURE__*/__webpack_require__.n(Title_styles_module);
;// CONCATENATED MODULE: ./components/pages/singleBlog/Title/index.js





var Title = function(param) {
    var content = param.content, count = param.count;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
        variant: [
            "-xs2",
            "-pxl"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "title-".concat(count),
                className: (Title_styles_module_default()).separator,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineSeparator/* default */.Z, {
                    variant: [
                        "center"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Title_styles_module_default()).title,
                children: addLinkTarget(content)
            })
        ]
    });
};
/* harmony default export */ var singleBlog_Title = (Title);

// EXTERNAL MODULE: ./components/pages/singleBlog/SideContent/styles.module.scss
var SideContent_styles_module = __webpack_require__(34009);
var SideContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(SideContent_styles_module);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/pages/singleBlog/SideContent/index.js










var SideContent = function(param) {
    var content = param.content;
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref.isMobile, isSmallMobile = ref.isSmallMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SideContent_styles_module_default()).side,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            variant: [
                "-xs"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns/* default */.Z, {
                variant: [
                    content.data.image_position === "right" && "reversed",
                    "-align-middle",
                    "-distribute-between"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                        variant: [
                            isMobile && "no-padding"
                        ],
                        spans: isSmallMobile ? 12 : 5,
                        children: (content.data.image || content.data.cloudflare_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SideContent_styles_module_default()).side__image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                                alt: "Image ".concat(content.title),
                                layout: "fill",
                                sizes: "(min-width: 1250px) 640px,(max-width: 640px) 100vw, 512px",
                                objectFit: "cover",
                                objectPosition: "50%",
                                src: (0,getS3Url/* getS3Url */.v)(content.data.cloudflare_image || content.data.image, "960")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                        spans: isSmallMobile ? 12 : 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,withModifiers/* withModifiers */.i)("side__description", [
                                content.data.image_position === "right" && "reversed"
                            ], (SideContent_styles_module_default())),
                            dangerouslySetInnerHTML: {
                                __html: addLinkTarget(content.data.paragraph)
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var singleBlog_SideContent = (SideContent);

// EXTERNAL MODULE: ./components/pages/singleBlog/ThreeImages/styles.module.scss
var ThreeImages_styles_module = __webpack_require__(44005);
var ThreeImages_styles_module_default = /*#__PURE__*/__webpack_require__.n(ThreeImages_styles_module);
;// CONCATENATED MODULE: ./components/pages/singleBlog/ThreeImages/index.js






var ThreeImages = function(param) {
    var content = param.content;
    var isDesktop = (0,ResponsiveContext/* useResponsive */.F)().isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
        variant: [
            "-xs",
            isDesktop && "-p0"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ThreeImages_styles_module_default()).grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ThreeImages_styles_module_default()).grid__item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                        layout: "fill",
                        sizes: "(min-width: 1250px) 590px, (max-width: 1250px) 70vw, 70vw",
                        objectFit: "cover",
                        objectPosition: "center",
                        src: (0,getS3Url/* getS3Url */.v)(content.data.cloudflare_image_one || content.data.image_one, "1980")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ThreeImages_styles_module_default()).grid__item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                        objectFit: "cover",
                        objectPosition: "center",
                        sizes: "(min-width: 1250px) 390px, (max-width: 1250px) 33vw, 70vw",
                        src: (0,getS3Url/* getS3Url */.v)(content.data.cloudflare_image_two || content.data.image_two, "960"),
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ThreeImages_styles_module_default()).grid__item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                        objectFit: "cover",
                        objectPosition: "center",
                        src: (0,getS3Url/* getS3Url */.v)(content.data.cloudflare_image_three || content.data.image_three, "960"),
                        layout: "fill"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var singleBlog_ThreeImages = (ThreeImages);

// EXTERNAL MODULE: ./components/pages/blog/Subscribe/index.js + 1 modules
var Subscribe = __webpack_require__(95109);
;// CONCATENATED MODULE: ./public/icons/icon-contact-phone.svg
var icon_contact_phone_path, _path2;

function icon_contact_phone_extends() { icon_contact_phone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_contact_phone_extends.apply(this, arguments); }



const SvgIconContactPhone = props => /*#__PURE__*/react.createElement("svg", icon_contact_phone_extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_contact_phone_path || (icon_contact_phone_path = /*#__PURE__*/react.createElement("path", {
  d: "M23.733 0C19.14 0 15.39 3.686 15.39 8.2c0 1.58.459 3.084 1.224 4.363.383.526.689.827 1.072 1.203 0 .075-.077.15-.077.301-.153.376-.383.903-.612 1.354l-1.072 1.956c-.153.3-.076.677.153.827l.383.15H16.692c.076 0 .076-.074.076-.074h.077c.076 0 .076-.076.153-.076.076-.075.306-.15.46-.3.382-.226.841-.602 1.377-.903.535-.301.995-.677 1.377-.903.23-.075.383-.226.46-.226h.076c.918.377 1.913.602 2.908.602 4.593 0 8.343-3.686 8.343-8.2C31.999 3.762 28.325 0 23.733 0Zm0 1.354c3.903 0 7.041 3.084 7.041 6.92 0 3.837-3.138 6.921-7.041 6.921-.995 0-1.913-.15-2.755-.526-.306-.075-.383-.075-.536-.075-.077 0-.23.075-.306.075-.153.075-.383.15-.613.3-.382.226-.841.527-1.3.828.229-.451.459-.827.612-1.203.076-.226.153-.452.23-.602 0-.076.076-.15.076-.301 0-.15 0-.376-.23-.602-.612-.527-.689-.602-1.071-1.204a6.662 6.662 0 0 1-1.072-3.61c0-3.912 3.138-6.996 6.965-6.921Zm.536 2.332c-.23 0-.383.075-.536.15-.153.15-.153.301-.153.527 0 .226.076.376.153.527.153.15.306.15.536.15.23 0 .382-.075.535-.15.154-.076.23-.301.23-.527a.677.677 0 0 0-.23-.527c-.153-.15-.382-.15-.535-.15Zm-.613 2.106c-.306 0-.688.15-1.071.527a4.836 4.836 0 0 0-.995 1.354h.612c.23-.376.46-.602.612-.752a.7.7 0 0 1 .536-.226c.077 0 .153 0 .153.075.077.075.077.15.077.226 0 .15-.153.602-.383 1.279-.153.376-.306.677-.383.902-.153.377-.23.677-.306.978-.076.301-.153.527-.153.753 0 .3.077.526.23.752.153.226.383.226.689.226.382 0 .765-.151 1.071-.452.306-.3.613-.752.919-1.43h-.613c-.23.377-.382.603-.535.753-.154.15-.306.226-.46.226-.076 0-.153 0-.23-.075-.076-.076-.076-.15-.076-.226 0-.075 0-.301.077-.527.076-.225.23-.601.383-1.128.23-.752.459-1.204.535-1.505.077-.3.153-.526.153-.677 0-.3-.076-.526-.23-.752-.076-.15-.306-.3-.612-.3Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M2.305.969c-.382.075-.841.3-1.071.677-.383.451-.612 1.053-.765 1.73-1.531 7.598.688 15.722 6.658 21.59 5.97 5.867 14.312 8.124 21.966 6.544.689-.15 1.3-.376 1.683-.752.383-.377.69-.978.613-1.58l-1.072-6.093c-.076-.602-.535-1.129-.995-1.43-.459-.3-.995-.526-1.53-.601l-4.516-.376c-.842-.15-1.53 0-2.066.376-.536.451-.766.978-.995 1.58v.075l-.536 1.805-1.148-.3c-2.755-.753-4.669-1.806-6.888-3.912-2.067-2.182-3.138-4.063-3.904-6.77l-.306-1.13 1.837-.526h.077c.612-.225 1.148-.451 1.607-.978.46-.376.536-1.053.46-1.88v-.075l-.46-4.439c-.077-.526-.23-1.053-.612-1.504-.306-.452-.842-.828-1.455-.978L2.765.969h-.46Zm.23 1.354 6.2 1.053c.152 0 .382.15.612.451.23.301.306.602.382.828l.383 4.438c.076.677 0 .903-.153 1.053-.153.15-.46.301-.995.527h-.077l-2.449.677c-.153.075-.306.15-.382.3-.077.151-.077.301-.077.527l.536 1.73c.765 2.859 2.066 5.04 4.21 7.372l.076.076c2.372 2.106 4.515 3.385 7.5 4.137l1.76.526a.478.478 0 0 0 .536-.075c.153-.075.306-.225.306-.451l.613-2.407v-.076c.23-.526.382-.827.535-.977.154-.15.383-.226 1.072-.15l4.515.375c.23 0 .613.15.919.376.306.226.46.377.46.602l1.07 6.093c0 .076 0 .15-.152.301-.153.15-.613.376-1.148.452-7.195 1.655-15.078-.527-20.741-6.018C2.382 18.496.239 10.748 1.693 3.602c.153-.527.306-.903.536-1.129.23-.225.23-.225.306-.15Z",
  fill: "currentColor"
})));

/* harmony default export */ var icon_contact_phone = (SvgIconContactPhone);
// EXTERNAL MODULE: ./public/icons/icon-x.svg
var icon_x = __webpack_require__(37021);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(53597);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(46616);
// EXTERNAL MODULE: ./public/icons/icon-facebook.svg
var icon_facebook = __webpack_require__(30967);
// EXTERNAL MODULE: ./public/icons/icon-linkedin.svg
var icon_linkedin = __webpack_require__(89796);
// EXTERNAL MODULE: ./components/pages/singleBlog/Actions/styles.module.scss
var Actions_styles_module = __webpack_require__(78996);
var Actions_styles_module_default = /*#__PURE__*/__webpack_require__.n(Actions_styles_module);
;// CONCATENATED MODULE: ./components/pages/singleBlog/Actions/index.js







var Actions = function(param) {
    var blog = param.blog;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: (Actions_styles_module_default()).actions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Actions_styles_module_default()).actions__label,
                children: "Share"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                url: "".concat( true && (window === null || window === void 0 ? void 0 : window.location.href), "\n                "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).actions__share,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_facebook/* default */.Z, {
                        width: 16,
                        height: 16
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
                url:  true && window.location.href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).actions__share,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_linkedin/* default */.Z, {
                        width: 16,
                        height: 16
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterShareButton/* default */.Z, {
                url:  true && window.location.href,
                title: blog.title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).actions__share,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_x/* default */.Z, {
                        width: 16,
                        height: 16
                    })
                })
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Actions_styles_module_default()).actions__connect,
                children: [
                    "Connect with Us",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        rel: "nofollow",
                        href: "tel: +1 213-805-0840",
                        className: (Actions_styles_module_default()).actions__call,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_contact_phone, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var singleBlog_Actions = (Actions);

// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./components/custom/BlogCard/index.js
var BlogCard = __webpack_require__(95948);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./pages/404/index.js
var _404 = __webpack_require__(6553);
// EXTERNAL MODULE: ./components/templates/LoadingPage/index.js
var LoadingPage = __webpack_require__(93019);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./pages/stories/[_name].js





























var ReactPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2004).then(__webpack_require__.bind(__webpack_require__, 22004));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22004)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
});
var ScrollLink = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2756), __webpack_require__.e(3096)]).then(__webpack_require__.bind(__webpack_require__, 66261)).then(function(mod) {
        return mod.Link;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66261)
            ];
        }
    },
    ssr: false
});
var CloudflareVideo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69562)
            ];
        }
    },
    ssr: false
});
var SingleBlog = function(param) {
    var blog = param.blog, headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, pageTranslation = param.pageTranslation, notFound = param.notFound;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref2.isMobile, isDesktop = ref2.isDesktop;
    var ref3 = (0,react.useState)(""), headings = ref3[0], setHeadings = ref3[1];
    var ref4 = (0,react.useState)(false), hasWindow = ref4[0], setHasWindow = ref4[1];
    var loadingTitle = {
        en: "Loading",
        fr: "Chargement",
        es: "Cargando",
        nl: "Bezig met laden"
    };
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage["default"], {
            title: loadingTitle[router.locale]
        });
    }
    (0,react.useEffect)(function() {
        if (true) {
            var elements = Array.from(document.querySelectorAll("h3, h4"));
            setHeadings(elements);
            elements.map(function(element, index) {
                element.setAttribute("id", "heading-".concat(index));
            });
        }
    }, []);
    (0,react.useEffect)(function() {
        if (true) {
            setHasWindow(true);
        }
    }, []);
    if (notFound || !(blog === null || blog === void 0 ? void 0 : blog.article)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {
            headerTranslation: headerTranslation,
            footerTranslation: footerTranslation
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page["default"], {
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        footer: false,
        meta: {
            title: "".concat(blog === null || blog === void 0 ? void 0 : blog.title, " | St. Martin Sotheby's Realty"),
            description: (ref1 = (ref = blog.short_description) === null || ref === void 0 ? void 0 : ref.replaceAll("<p>", "")) === null || ref1 === void 0 ? void 0 : ref1.replaceAll("</p>", ""),
            image: (0,getS3Url/* getS3Url */.v)(blog.cloudflare_hero_image || blog.hero_image, "1980")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(singleBlog_Welcome, {
                title: blog === null || blog === void 0 ? void 0 : blog.title,
                date: moment_default()(blog.published_date).utc().format("MMM DD, YYYY"),
                image: blog.cloudflare_hero_image || blog.hero_image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (stories_styles_module_default()).page,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (stories_styles_module_default()).blog,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(singleBlog_Actions, {
                                blog: blog
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (stories_styles_module_default()).blog__content,
                                children: [
                                    blog.summary_content && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                                        variant: [
                                            "-xs2",
                                            "-pxl"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (stories_styles_module_default()).blog__welcome,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (stories_styles_module_default()).blog__title,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_summary, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            children: pageTranslation.content.summary[router.locale]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: blog.summary_content
                                                    }
                                                }),
                                                (headings === null || headings === void 0 ? void 0 : headings.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (stories_styles_module_default()).blog__table,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (stories_styles_module_default()).blog__title,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_table_contents, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    children: pageTranslation.content.toc[router.locale]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: headings.map(function(item, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: (stories_styles_module_default()).blog__link,
                                                                    children: hasWindow && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollLink, {
                                                                        spy: true,
                                                                        smooth: true,
                                                                        offset: -200,
                                                                        duration: 500,
                                                                        to: "heading-".concat(index),
                                                                        children: item.innerText
                                                                    })
                                                                }, "nav-link-".concat(index));
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    blog.article && blog.article.map(function(item, index) {
                                        switch(item.type){
                                            case "paragraph":
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(singleBlog_Paragraph, {
                                                    content: item.data.article_content_paragraph
                                                }, "inner-section-".concat(index));
                                            case "title":
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(singleBlog_Title, {
                                                    count: index,
                                                    content: item.data.article_content_title
                                                }, "inner-section-".concat(index));
                                            case "paragraph_and_side_images":
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(singleBlog_SideContent, {
                                                    content: item
                                                }, "inner-section-".concat(index));
                                            case "full_width_image":
                                                if (item.data.full_width_image || item.data.cloudflare_full_width_image) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (stories_styles_module_default()).blog__section,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                                                            variant: [
                                                                "-xs",
                                                                isDesktop && "-p0"
                                                            ],
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (stories_styles_module_default()).blog__image,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                                                                    sizes: "(min-width: 1250px) 978px, (max-width: 1250px) 100vw, 70vw",
                                                                    objectFit: "cover",
                                                                    objectPosition: "center",
                                                                    layout: "fill",
                                                                    src: (0,getS3Url/* getS3Url */.v)(item.data.cloudflare_full_width_image || item.data.full_width_image)
                                                                })
                                                            })
                                                        })
                                                    }, "inner-section-".concat(index));
                                                }
                                                return;
                                            case "three_images":
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(singleBlog_ThreeImages, {
                                                    content: item
                                                }, "inner-section-".concat(index));
                                            case "video":
                                                if (hasWindow) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                                                        variant: [
                                                            isMobile && "-p0"
                                                        ],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (stories_styles_module_default()).blog__section,
                                                            children: [
                                                                (item.data.own_video || item.data.cloudflare_own_video) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: item.data.cloudflare_own_video ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudflareVideo, {
                                                                        loop: true,
                                                                        src: item.data.cloudflare_own_video,
                                                                        height: "auto",
                                                                        controls: true
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
                                                                        loop: true,
                                                                        url: (0,getS3Url/* getS3Url */.v)(item.data.own_video),
                                                                        controls: true,
                                                                        width: "100%",
                                                                        height: "auto"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: item.data.youtube_video && (stories_styles_module_default()).blog__video,
                                                                    children: item.data.youtube_video && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
                                                                        loop: true,
                                                                        url: item.data.youtube_video || (0,getS3Url/* getS3Url */.v)(item.data.own_video),
                                                                        controls: true,
                                                                        width: "100%",
                                                                        height: "auto"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, "-video-".concat(index));
                                                }
                                                return;
                                        }
                                    }),
                                    blog.footnote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                                        variant: [
                                            "-xs2",
                                            "-pxl"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: blog.footnote
                                            },
                                            className: (stories_styles_module_default()).blog__footnote
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscribe/* default */.Z, {
                                title: pageTranslation.subscribe.title[router.locale],
                                description: pageTranslation.subscribe.description[router.locale],
                                translations: footerTranslation.form,
                                variant: [
                                    "gray",
                                    "separator",
                                    "separator-top"
                                ]
                            }),
                            !(0,isEmpty/* default */.Z)(blog.recommended) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
                                separator: true,
                                variant: [
                                    "white",
                                    "separator-top",
                                    "p-xl"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
                                    variant: [
                                        "-xs"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (stories_styles_module_default()).blog__intro,
                                            children: pageTranslation.cards.explore[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (stories_styles_module_default()).blog__recommended,
                                            children: blog.categories
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns/* default */.Z, {
                                            className: (stories_styles_module_default()).columns,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                                    spans: isMobile ? 12 : isDesktop ? 6 : 7,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, blog.recommended[0]), {
                                                        variant: [
                                                            "similar"
                                                        ],
                                                        image: blog.recommended[0].picture || blog.recommended[0].image,
                                                        buttonLabel: pageTranslation.cards.button[router.locale]
                                                    }))
                                                }),
                                                blog.recommended[1] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                                    spans: isMobile ? 12 : isDesktop ? 6 : 5,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, blog.recommended[1]), {
                                                        variant: [
                                                            "similar"
                                                        ],
                                                        image: blog.recommended[1].picture || blog.recommended[1].picture,
                                                        buttonLabel: pageTranslation.cards.button[router.locale]
                                                    }))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _name_ = (SingleBlog);


/***/ }),

/***/ 51472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ny": function() { return /* binding */ ModalContextProvider; },
/* harmony export */   "vR": function() { return /* binding */ useModalContext; }
/* harmony export */ });
/* unused harmony export ModalContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useModalContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var ModalContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), variant = ref2[0], setVariant = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), beforeClose = ref3[0], handleBeforeClose = ref3[1];
    var body =  true && document.querySelector("body");
    var handleShowModal = function() {
        setShow(true);
        body.classList.add("modal-open");
    };
    var handleCloseModal = function() {
        setShow(false);
        body.classList.remove("modal-open");
        // Clear content to reset state when modal closes
        // This ensures errors and form state are cleared for next opening
        setContent(false);
        setVariant([]);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) {
            beforeClose && beforeClose();
            handleCloseModal();
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: {
            handleShowModal: handleShowModal,
            handleCloseModal: handleCloseModal,
            handleBeforeClose: handleBeforeClose,
            setContent: setContent,
            content: content,
            setVariant: setVariant,
            show: show,
            variant: variant
        },
        children: children
    });
};



/***/ }),

/***/ 42998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__LP5R2","separator--vertical":"styles_separator--vertical__XAMVo","separator--center":"styles_separator--center__qDfXg","separator--full-width":"styles_separator--full-width__WOn53"};

/***/ }),

/***/ 78897:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__sgQJp","loading":"styles_loading__2EGmZ","spinner--white":"styles_spinner--white__wuXJ0","spinner--darker":"styles_spinner--darker__oN4CN","spinner--black":"styles_spinner--black__LbiGp"};

/***/ }),

/***/ 78996:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__ZzwY1","actions__call":"styles_actions__call__T0UKN","actions__share":"styles_actions__share___FNwj","actions__connect":"styles_actions__connect__kQPSw"};

/***/ }),

/***/ 58886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"styles_paragraph__HCQjT"};

/***/ }),

/***/ 34009:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"side":"styles_side__ZwW8Z","side__image":"styles_side__image__i1DCl","side__description":"styles_side__description__3TIKj","side__description--reversed":"styles_side__description--reversed__DVKkR"};

/***/ }),

/***/ 44005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__aP64k","grid__item":"styles_grid__item__8a7tg"};

/***/ }),

/***/ 78576:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__PwrYA","title":"styles_title__2n90U"};

/***/ }),

/***/ 52976:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro__title":"styles_intro__title__0H4Z5","intro__subtitle":"styles_intro__subtitle__3w8TD","intro__image":"styles_intro__image__HAbzE"};

/***/ }),

/***/ 17570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__NPbYR","page__spinner":"styles_page__spinner__MIrmj"};

/***/ }),

/***/ 91298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__hoAMN","content__title":"styles_content__title__t_t8G","content__description":"styles_content__description__3suem","content__separator":"styles_content__separator__BUjYs"};

/***/ }),

/***/ 86810:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__rWNZR","blog":"styles_blog__N4v07","blog__label":"styles_blog__label__nO79U","blog__video":"styles_blog__video__W1zuQ","blog__section":"styles_blog__section__p4XtI","blog__table":"styles_blog__table__iEbEh","blog__link":"styles_blog__link__rNY3P","blog__content":"styles_blog__content__EHU4C","blog__image":"styles_blog__image__5bclZ","blog__title":"styles_blog__title__rry_P","blog__footnote":"styles_blog__footnote__LOS_4","blog__welcome":"styles_blog__welcome__n_mZd","blog__intro":"styles_blog__intro__0njmA","blog__recommended":"styles_blog__recommended__0cTcJ","columns":"styles_columns__hBZXk"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3790,2756,5675,175,6820,8433,3817,6268,9774,945,2888,179], function() { return __webpack_exec__(28264); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);